export const getDeployment = (): 'preview' | 'staging' | 'production' => {
  const hostname = location.hostname;
  if (
    hostname.includes('preview.stage.bio') ||
    hostname.includes('localhost') ||
    hostname.includes('192.168') ||
    hostname.includes('0.0.0.0')
  ) {
    return 'preview';
  } else {
    return 'production';
  }
};
